import { BaseModel } from "./base/base.model";

export class AppUsuario extends BaseModel {
  user1?: string;
  nif!: string;
  mail?: string;
  section!: { section1: string; name: string };
  roles!: { role1: string; name: string }[];
  rolesIds?: string[];
  name?: string;
  surname1?: string;
  surname2?: string;
  surnames?: string;
  fullName?: string;
  address?: {
    acronym?: string,
    streetName?: string,
    buildingNumber?: string,
    stairWell?: string,
    floor?: string,
    gate?: string,
    town?: string,
    country?: string,
    countryName?: string,
    postalCode?: string
  };
  company?: { companyName: string; id: string, company1: string, identifierNumber: string, appId: string, companyCode?: number };
  enabled!: boolean;
  dropDate!: Date;
  nameWithNif?: string;
  _isNew: boolean;

}

